import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Empty, Popover } from 'antd';

import OntraccrTag from '../common/OntraccrTag';

import { safeExtractFromObject } from '../helpers/helpers';

export default function Labels({
  size,
  labels = [],
  showEmpty = true,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;
  const labelTags = useMemo(() => labels.map(({ title: label } = {}) => (
    <OntraccrTag
      key={label}
      style={hasRedesign
        ? {
          margin: 2,
        }
        : {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 250,
        }}
    >
      {label}
    </OntraccrTag>
  )), [labels, hasRedesign]);

  if (size === 'small') {
    if (labels.length === 0) return null;
    return (
      <Popover
        title="Labels"
        placement="bottom"
        content={(
          <div style={{ maxWidth: 250 }}>
            {labelTags}
          </div>
        )}
      >
        <div
          style={{
            maxWidth: 140,
            maxHeight: hasRedesign ? 26 : 38,
            overflow: 'hidden',
            fontSize: 10,
          }}
        >
          {
            labels.map((label) => (
              <OntraccrTag
                size="small"
                style={
                  hasRedesign
                    ? {
                      margin: 2,
                      float: 'left',
                    }
                    : {
                      fontSize: 10,
                      height: 16,
                      lineHeight: '12px',
                      padding: '0px 2px',
                      margin: 2,
                      maxWidth: 138,
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      float: 'left',
                    }
                }
                key={label.id}
              >
                {label.title}
              </OntraccrTag>
            ))
          }
        </div>
      </Popover>
    );
  }

  if (showEmpty && labels.length === 0) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  return (
    <div id="user-label-container">
      {labelTags}
    </div>
  );
}
